import React from 'react';
import PropTypes from 'prop-types';
import './LabeledSelect.scss';

import InfoTip from './InfoTip';

// A micro-label and a select: the control the ledger views use for ranges, filters and the check.
const LabeledSelect = ({ label, tip, value, onChange, options }) => (
  <label className='labeled-select'>
    <span className='select-label'>
      {label}
      {tip && <InfoTip message={tip} />}
    </span>
    <select value={value} onChange={e => onChange(e.target.value)}>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </label>
);

LabeledSelect.propTypes = {
  label: PropTypes.string.isRequired,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired })).isRequired
};

export default LabeledSelect;
